import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {
  RoutesViewSettingsResourcesModel,
  RoutesViewSettingsServicesModel
} from "../../../../routes/models/routes-view-settings.model";
import {ResourceAllocationTimeWindowExtModel} from "../../../models/resource-allocation-time-window-ext.model";

require('./resources-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-resources-panel-list-item',
  templateUrl: './resources-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResourcesPanelListItemComponent implements OnInit, OnChanges {

  @Input() resource: ResourceAllocationTimeWindowExtModel;
  @Input() isSelected: boolean;
  @Input() settings: RoutesViewSettingsResourcesModel;
  @Input() itemElementSize: string;
  @Input() canClose?: boolean;
  @Output() onViewJob = new EventEmitter<boolean>();
  @Output() onToggle = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<any>();

  public isHover: boolean;
  public indexesInRoute: {index: number, isHighlighted: boolean}[];
  public routeColor: string;
  public serviceTags: string[];
  public totalDuration: number = 0;
  public routeNames: string[] = [];

  constructor(
    @Inject('splitService') private splitService,
    @Inject('$timeout') private $timeout,
    @Inject('planningCommonService') private planningCommonService) {}

  ngOnInit() {
    this._setTotalDuration();
    // this._setServiceTags();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.resource && !changes.resource.isFirstChange()) {
      this._setTotalDuration();
    }
  }

  onToggleEvent($event) {
    this.onToggle.emit(!this.isSelected)
  }

  onHover(isHover) {
    this.isHover = isHover;
    this.$timeout(0).then(() => {});
  }

  private _setTotalDuration() {
    this.totalDuration = this.resource.routes?.reduce((acc, route) => acc + route.totalTimeSec, 0) || 0;
    this.routeNames = (this.resource.routes || []).map(r => r.name || r.id);
  }

  // private _setLabels() {
  //   this.labels = _.uniq(_.compact(_.flatMap(this.job.packages, 'labels')));
  // }

  // private _setRouteIndexes() {
  //   this.indexesInRoute = [];
  //
  //   if (this.route?.activities.length) {
  //     this.route.activities.forEach((a, i) => {
  //       const jobIds = a.jobIds || (a.jobId ? [a.jobId] : [])
  //       if (_.includes(jobIds, this.job.id)) {
  //         this.indexesInRoute.push({index: (a.indexInRoute || i), isHighlighted: a.id === this.highlightedActivity?.id});
  //       }
  //     })
  //   }
  //
  // }

  // private _setServiceTags() {
  //   this.serviceTags = [];
  //
  //   if (!!this.service.tagNames?.length) {
  //     this.serviceTags = this.serviceTags.concat(this.service.tagNames);
  //   }
  //
  //   if (!!this.service.accountReference?.tags?.length) {
  //     this.serviceTags = this.serviceTags.concat(this.service.accountReference.tags);
  //   }
  // }


}
